import { ToggleButtonGroup } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
    gap: theme.spacing(0.2),
}));

export { PeekToggleButtonGroup, PeekToggleButtonGroup as default };
